import { createReducer, on } from "@ngrx/store";
import {
  nextcloudJwtChanged,
  nextcloudStateChanged,
  statsNews24hGeomapSuccess,
} from "../actions/news.actions";

export const initialState = {
  platforms: ["cyber", "innotech", "krimisi"],
  nextcloudState: "",
  nextcloudJwt: "",
};

// tslint:disable-next-line: variable-name
const _globalSettingsReducer = createReducer(
  initialState,
  on(nextcloudStateChanged, (state, { value }) => ({
    ...state,
    nextcloudState: value,
  })),
  on(nextcloudJwtChanged, (state, { value }) => ({
    ...state,
    nextcloudJwt: value,
  }))
);

export function globalSettingsReducer(state, action) {
  return _globalSettingsReducer(state, action);
}
